import(/* webpackMode: "eager" */ "/home/runner/work/devpath-ai/devpath-ai/app/learn/new/page.tsx");
